<div *ngIf="!value?.length" (dblclick)="!noEdit && addNew()" class="row m-b-xs">
    <div class="dv-label strong {{labelClass}}" *ngIf="!hideEmptyArrayLabel">{{title}}</div>

    <div class="dv-value {{contentClass}}">
        <span>-</span>
        <i *ngIf="!noEdit" (click)="addNew()" class="icon-plus pull-right" data-placement="top" title="Add New Phone"></i>
    </div>
</div>

<div (dblclick)="editModeOn()" class="row m-b-xs"
     *ngFor="let item of value; let i = index; let first = first; let last = last;">
    <div class="dv-label strong {{labelClass}}" *ngIf="!hideEmptyArrayLabel && !isEditMode">{{first ? title : ''}}</div>
    <div class="dv-value {{contentClass}}" [class.hidden]="isEditMode">
        <div>{{item.name}}</div>
        <div>{{item.phone}}</div>
        <div>{{item.email}}</div>
        <div>{{item.relation}}</div>
        <div>
            <pre>{{item.note}}</pre>
        </div>
        <div *ngIf="item.userName">Assigned To: {{item.userName}}</div>

        <i *ngIf="!noEdit" (click)="delete(i)" class="fa fa-trash pull-right" data-toggle="tooltip" data-placement="top"
           title="Delete"></i>
        <i *ngIf="!noEdit" (click)="editModeOn()" class="fa fa-pencil pull-right" data-toggle="tooltip" data-placement="top"
           title="Edit"></i>
    </div>

    <div class="dv-value-edit dv-phone-block" [class.hidden]="!isEditMode" style="display: block;">
        <div class="{{labelClass}} m-b-sm">Name</div>
        <div class="{{contentClass}} m-b-sm">
            <input (keyup.enter)="apply()" class="form-control"
                   [ngModel]="item.name"
                   name="name[{{i}}]"
                   id="name[{{i}}]"
                   maxlength="255"
                   (input)="updateProperty('name', $event.target.value, i)">
        </div>

        <div class="{{labelClass}} m-b-sm">Phone</div>
        <div class="{{contentClass}} m-b-sm">
            <input (keyup.enter)="apply()" class="form-control"
                   [ngModel]="preparePhoneForInput(item)"
                   name="phone[{{i}}]"
                   id="phone[{{i}}]"
                   maxlength="255"
                   (input)="updateProperty('phone', $event.target.value, i)">
        </div>

        <div class="{{labelClass}} m-b-sm">Email</div>
        <div class="{{contentClass}} m-b-sm">
            <input (keyup.enter)="apply()" class="form-control"
                   [ngModel]="item.email"
                   name="email[{{i}}]"
                   id="email[{{i}}]"
                   maxlength="255"
                   (input)="updateProperty('email', $event.target.value, i)">
        </div>

        <div class="{{labelClass}} m-b-sm">Relation</div>
        <div class="{{contentClass}} m-b-sm">
            <input (keyup.enter)="apply()" class="form-control"
                   [ngModel]="item.relation"
                   name="relation[{{i}}]"
                   id="relation[{{i}}]"
                   maxlength="255"
                   (input)="updateProperty('relation', $event.target.value, i)">
        </div>

        <div class="col-sm-12 m-b-sm" *ngIf="!users || users.length < 1">
            <div class="radio-box" style="padding: 0;">
                <input type="radio"
                       name="primary[{{i}}]"
                       [checked]="item.isPrimary"
                       (click)="updatePrimary(i)"
                       [value]="i"
                       id="primary-{{i}}">
                <label for="primary-{{i}}"> Primary</label>
            </div>
        </div>

        <div class="{{labelClass}} m-b-sm">Note</div>
        <div class="{{contentClass}} m-b-sm">
            <textarea class="form-control"
                      name="note[{{i}}]"
                      maxlength="255"
                      [ngModel]="item.note"
                      (input)="updateProperty('note', $event.target.value, i)">
            </textarea>
        </div>

        <div class="{{labelClass}} m-b-sm" *ngIf="users && users.length > 0">Resident</div>
        <div class="{{contentClass}} m-b-sm" *ngIf="users && users.length > 0">
            <select class="form-control" name="user[{{i}}]" [(ngModel)]="item.user" style="width: 100%">
                <option [ngValue]="null">Unassigned</option>
                <option *ngFor="let user of users" [value]="user.user.id">{{user.user.fullName}}</option>
            </select>
        </div>

        <div class="col-sm-12 display-flex m-b-sm">
            <button *ngIf="!editOnly" type="button" (click)="apply()"><i class="fa fa-check"></i></button>
            <button type="button" (click)="cancel(i)"><i class="fa fa-times"></i></button>
            <button type="button" (click)="remove(i)">
                <i class="fa fa-trash m-n" style="opacity: 1;"></i>
            </button>
        </div>

        <hr *ngIf="!last">
    </div>
</div>

<div *ngIf="value?.length && !noEdit" class="row">
    <div class="col-sm-12">
        <i class="icon-plus pull-right" (click)="addNew()" id="add-new-phone"
           data-toggle="tooltip" data-placement="top" title="Add New Phone"></i>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/fields/emergency-contacts-field/emergency-contacts-field.component.html